import type { ModalProps } from "@/types/modal"
import { defineStore } from "pinia"

export const useModal = defineStore("modal", {
  state: () => ({
    items: [] as ModalProps[]
  }),

  getters: {
    isOpen: state => state.items.length > 0
  },

  actions: {
    triggerModal(modal: ModalProps) {
      this.openModal(modal)
    },

    openModal(modal: ModalProps) {
      this.items.push(modal)
    },

    closeModal() {
      this.items.pop()
    },

    closeAll() {
      this.items = [] as ModalProps[]
    }
  }
})
